import { styled } from 'styled-components';
import mediaQuery, { Breakpoint, breakpoints } from '@/styles/mediaQuery';

export const PartnerTokenExchangeTitle = styled.h2`
  font-size: ${({ theme }) => theme.typography.sizes.lg};

  ${mediaQuery.custom(breakpoints[Breakpoint.XS])} {
    font-size: ${({ theme }) => theme.typography.sizes.sm};
    margin-bottom: ${({ theme }) => theme.spaces.padding.md};
  }
`;

export const PartnerTokenExchangeSubtitle = styled.p`
  margin-bottom: ${({ theme }) => theme.spaces.padding.md};
  color: ${({ theme }) => theme.system.neutral.text.muted};
`;

export const InputContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spaces.padding.md};
`;

export const FieldHint = styled.p`
  margin: ${({ theme }) => theme.spaces.padding.xs} 0 0;
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.system.neutral.text.muted};
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spaces.gap.md};
  width: 100%;
  margin-top: ${({ theme }) => theme.spaces.padding.md};
`;

export const CredentialsWarning = styled.div`
  margin-bottom: ${({ theme }) => theme.spaces.padding.md};
  padding: ${({ theme }) => theme.spaces.padding.md};
  border: 1px solid ${({ theme }) => theme.system.warning.border.primary};
  border-radius: ${({ theme }) => theme.radius.base};
  background-color: ${({ theme }) => theme.system.warning.surface.subtle};
  color: ${({ theme }) => theme.system.warning.text.primary};
`;

export const CredentialRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spaces.gap.md};
  margin-bottom: ${({ theme }) => theme.spaces.padding.md};

  & > :first-child {
    flex: 1;
    min-width: 0;
  }
`;
